import { useState } from 'react'
import TicketService from '../services/TicketService/TicketService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useTicket = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingTicketCreating: false,
    isLoadingTicketDelete: false,
    isLoadingTicketUpdate: false,
    isLoadingTicketsByParams: false,
    isLoadingTicketChangeStatus: false
  });

  const [modalState, setModalState] = useState({
    showModalInfoTicket: false,
    showModalCreateTicket: false,
    showModalDeleteTicket: false,
    showModalUpdateTicket: false,
    showModalChangeStatusTicket: false
  });

  const getTicketsByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingTicketsByParams: true });
    try {
      let obj;
      let response = await TicketService.getTicketsByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketsByParams: false });
    }
  }

  const createTicket = async (data) => {
    setLoadingState({ ...loadingState, isLoadingTicketCreating: true });
    try {
      let response = await TicketService.createTicket(data);
      alertService.success("Ticket creato con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateTicket: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketCreating: false });
    }
  }

  const deleteTicket = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingTicketDelete: true });
      let response = await TicketService.deleteTicket(id);
      const res = await response.json();
      alertService.success("Ticket eliminato con successo", {autoClose: true});
      setModalState({...modalState, showModalDeleteTicket: false });
      return res;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketDelete: false });
    }
  }

  const updateTicket = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingTicketUpdate: true });
      let response = await TicketService.updateTicket(data);
      alertService.success("Ticket aggiornato con successo", {autoClose: true});
      setModalState({...modalState, showModalUpdateTicket: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketUpdate: false });
    }
  }

  const changeTicketStatus = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingTicketChangeStatus: true });
      let response = await TicketService.changeTicketStatus(data);
      alertService.success("Stato ticket aggiornato con successo", {autoClose: true});
      setModalState({...modalState, showModalChangeStatusTicket: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketChangeStatus: false });
    }
  }

  return {
    createTicket,
    loadingStateTicket: loadingState,
    modalStateTicket: modalState,
    setModalStateTicket: setModalState,
    updateTicket,
    deleteTicket,
    getTicketsByParams,
    changeTicketStatus
  };
}

export default useTicket;

